import { appendReduxParts } from "infrastructure/store";

import { appSaga as dictionaryLinksSaga } from "./message-details/dictionary-links/DictionaryLinks.saga";
import { dictionaryLinks } from "./message-details/dictionary-links/DictionaryLinks.slice";
import { appSaga as messageFormatSaga } from "./message-details/message-id/MessageId.saga";
import { messageFormat } from "./message-details/message-id/MessageId.slice";
import { appSaga as relationshipsSaga } from "./message-details/message-relationships/MessageRelationships.saga";
import { messageRelationships } from "./message-details/message-relationships/MessageRelationships.slice";
import { appSaga as messageTranslationsSaga } from "./message-details/message-translations/MessageTranslations.saga";
import { messageTranslations } from "./message-details/message-translations/MessageTranslations.slice";

export * from "./messages";
export * from "./message-details";
export * from "./plex-translation-messages";
export * from "./translation-managers.localization";
export * from "./translation-messages";

appendReduxParts(
  [
    {
      reducerName: dictionaryLinks.name,
      reducer: dictionaryLinks.reducer
    },
    {
      reducerName: messageRelationships.name,
      reducer: messageRelationships.reducer
    },
    {
      reducerName: messageFormat.name,
      reducer: messageFormat.reducer
    },
    {
      reducerName: messageTranslations.name,
      reducer: messageTranslations.reducer
    }
  ],
  [dictionaryLinksSaga(), relationshipsSaga(), messageFormatSaga(), messageTranslationsSaga()]
);
